import {useStore} from '@/store/root-store';
import {Popover} from 'antd';
import {observer} from 'mobx-react';
import React, {useState, useEffect, useRef} from 'react';
import styled from 'styled-components';
import {Globe} from 'react-feather';
import {setCountryCodeToLocalStorage, getCountryCodeFromLocalStorage} from '@/api/common-utils';
import {useRouter} from 'next/router';
import {toJS} from 'mobx';
import {countryFlag} from '@/utils/countries';
import classNames from 'classnames';
import styles from './style.module.scss';
import {opaqueColor} from '@/utils/colors';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons';
import {faGear} from '@fortawesome/pro-light-svg-icons';

interface CountryPickerV2Props {
  mode?: 'dark' | 'light';
  showCountries?: boolean;
  disabled?: boolean;
}


export const CountryDropdownV2 = observer(({showCountries = true, mode = 'light', disabled = false}: CountryPickerV2Props) => {
  const {countries: {getSpecificCountryByCode, countriesData}, settings: {customer}} = useStore('');
  const {navBar, gsc: {criteria}} = useStore('');

  const [open, setOpen] = useState(false);

  const popupRef = useRef<any>();

  const freeTrial = customer.isFreeTrialExpire;
  const {settings: {customer: {profile: {productOverview}}}} = useStore('');
  const router = useRouter();
  const [country, setCountry] = useState('');
  const currentProperty = navBar.getSiteProperty(criteria.property);
  const availableCountryData = toJS(currentProperty?.availableCountryCodes)?.filter(code => !currentProperty?.activeCountryCodes?.includes(code)).map(item => {
    return {
      code: item,
      ...getSpecificCountryByCode(item),
    };
  });
  const countryData = toJS(currentProperty?.trafficValue)?.map(item => ({
    code: item.countryCode,
    ...getSpecificCountryByCode(item.countryCode),
    value: item.value,
    emojiflag: getSpecificCountryByCode(item.countryCode)?.emoji,
  })).sort((a, b) => b.value - a.value);
  const appendParams = (value, countryCode?: string) => {
    let params = '';
    if ('sp' in router.query) {
      delete router.query['sp'];
    }
    if ('country_code' in router.query) {
      delete router.query['country_code'];
    }
    router.query['sp'] = value;
    router.query['country_code'] = countryCode;
    Object.keys(router.query).forEach(param => {
      if (param !== 'slug') {
        if (!params) {
          params = `?&${param}=${router.query[param]}`;
        } else {
          params += `?&${param}=${router.query[param]}`;
        }
      }
    });
    return params;
  };
  const onCountryChange = (value: string) => {
    router.push(
      `${location.pathname}${appendParams(criteria.property, value)}`,
      undefined,
      {shallow: true},
    );
    criteria.updateCriteria({
      ...criteria,
      countryCode: value,
    });
    setCountryCodeToLocalStorage(value);
    setCountry(value);
  };

  useEffect(() => {
    setCountry(getCountryCodeFromLocalStorage());
  }, [currentProperty, getCountryCodeFromLocalStorage(), JSON.stringify(countriesData)]);
  const handleInactiveCountryClick = () => {
    navBar.setIsActivatePropertiesDrawerOpen();
  };

  // sets up an event listener that should clsoe the modal if anywhere outside the screen is clicked
  useEffect(() => {
    function handleClickOutside(event) {
      const x = event.clientX; const y = event.clientY;
      const elementMouseIsOver = document.elementFromPoint(x, y);

      if (popupRef.current &&
            Boolean(elementMouseIsOver?.closest('.countryPickerPopoverTriggerClass')) ||
            Boolean(elementMouseIsOver?.closest('.countryPickerPopoverClass'))) {
        event.preventDefault();
      } else {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupRef]);

  /**
   *
   * @param {boolean} visible represents cur visibilty of the popup
   */
  const handleOpenChange = (visible: boolean) => {
    if (visible) {
      // update dountries logic goes here
    }
  };

  const countryPickerRender = () => (<>

    <PopupWrapper>

      <TopTooltipSection mode={mode}>
        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 10}}>
          <div style={{fontSize: 12, fontWeight: 500}}>Active</div>
        </div>
        {countryData?.map((item, index) => {
          const availableContry = availableCountryData.some( element => element['code'] == item.code );

          // if there is no country code

          return !availableContry ?
            item.code == '' ?
              <SingleCountryItem
                isActive={country == ''}
                key={''}
                onClick={() => onCountryChange('')}>
                <Globe style={{height: '17px', width: '17px', color: mode == 'dark' ? 'white' : '#4E5156'}}/>
                <CountryName mode={mode}>Worldwide</CountryName>
              </SingleCountryItem> :
              <SingleCountryItem
                isActive={toJS(criteria).countryCode == item.code}
                key={index}
                onClick={() => onCountryChange(item.code)}>
                {countryFlag(item?.code, '20px')}
                <CountryName mode={mode}>{getSpecificCountryByCode(item.code)?.name}
                </CountryName>
              </SingleCountryItem> : null;
          // if there is  country code
        })}
      </TopTooltipSection>
      <BottomTooltipSection mode={mode}>
        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 10}}>
          <div style={{fontSize: 12, fontWeight: 500}}>Inactive</div>
          <div style={{fontSize: 12, fontWeight: 500, color: '#2D6CCA', cursor: 'pointer'}} onClick={() => {
            handleInactiveCountryClick();
            setOpen(false);
          }}>
            <FontAwesomeIcon icon={faGear} style={{color: '#2D6CCA', marginRight: 5}}/>
          Manage
          </div>
        </div>
        {countryData?.map((item, index) => {
          const availableContry = availableCountryData.some( element => element['code'] == item.code );

          // if there is no country code

          return availableContry ?
            item.code == '' ?
              <SingleCountryItem
                isDisabled={true}
                key={''}>
                <Globe style={{height: '17px', width: '17px', color: mode == 'dark' ? 'white' : '#4E5156'}}/>
                <CountryName mode={mode}>Worldwide</CountryName>
              </SingleCountryItem> :
              <SingleCountryItem
                isDisabled={true}
                isActive={toJS(criteria).countryCode == item.code}
                key={index}>
                {countryFlag(item?.code, '20px')}
                <CountryName mode={mode}> {getSpecificCountryByCode(item.code)?.name} </CountryName>
              </SingleCountryItem> : null;
          // if there is  country code
        })}
      </BottomTooltipSection>
    </PopupWrapper>
  </>);

  return (
    <div>
      {showCountries && !(freeTrial && productOverview) && <Popover
        ref={popupRef}
        overlayClassName={classNames(styles.CountryPickerPopover, 'countryPickerPopoverClass')}
        content={countryPickerRender}
        placement={mode == 'dark' ? 'right': 'bottomLeft'}
        trigger='click'
        visible={open && !disabled}
        onVisibleChange={visible => handleOpenChange(visible)}
        overlayInnerStyle={{marginTop: mode == 'dark' ? '190px' : '', width: 'auto', borderRadius: 12, overflow: 'hidden', backgroundColor: mode=='dark' ? '#2D2F34' : ''}}
      >
        <SelectedCountryWrapper mode={mode} onClick={() => setOpen(!open)} className='countryPickerPopoverTriggerClass' disabled={disabled}>
          {country == '' ? <Globe style={{height: '17px', width: '17px', color: '#fff'}}/> : countryFlag(country, '20px')}
          <span style={{marginLeft: 5, color: '#fff'}}>{country == '' ? 'Worldwide' : getSpecificCountryByCode(country)?.name}</span>
          <FontAwesomeIcon icon={faCaretDown} style={{color: '#fff', marginLeft: 5}}/>
        </SelectedCountryWrapper>
      </Popover>}

    </div>
  );
});
const backgroundByMode = (mode: CountryPickerV2Props['mode']) => {
  if (!mode || mode == 'dark') return opaqueColor('#4E5156', 35);
  else {
    return '#4E515659';
  }
};
const hoverBackgroundByMode = (mode: CountryPickerV2Props['mode']) => {
  if (!mode || mode == 'dark') return opaqueColor('#4E5156', 50);
};

const SelectedCountryWrapper = styled.div<{mode?: CountryPickerV2Props['mode']; disabled?: boolean}>`
  width: fit-content;
  padding: 5px 10px 6px;
  color: #fff;
  background-color: ${p => backgroundByMode(p.mode)};
  border-radius: 6px;
  cursor: ${p => p?.disabled ? 'not-allowed' : 'pointer'};
  ${p => p?.disabled ? 'opacity: 0.4' : ''};
  align-items: center;
  transition: background-color .2s ease;
  display: flex;
  align-items: center;

  &:hover {
    background-color:  ${p => hoverBackgroundByMode(p.mode)};
  }
`;
const PopupWrapper = styled.div`
  max-height: 350px;
  overflow: auto;
  &::-webkit-scrollbar{
      width:5px;
      background-color:#313337;
      }
      
  &::-webkit-scrollbar-thumb{
    background:#8d8d8d;
    border-radius:5px;
  }
`;
const SingleCountryItem = styled.div<{isActive?: boolean; isDisabled?: boolean}>`
  cursor: ${p => !p.isDisabled ? 'pointer' : 'default'}; ;
  padding: 5px 10px;
  margin-bottom: 2px;
  border-radius: 6px;
  transition: background .2s ease;
  display: flex;
  align-items: center;

  background: ${p => p.isActive ? opaqueColor('#7F4EAD', 20) : 'transparent'}; 

  &:hover {
    background: ${p => !p.isDisabled ? opaqueColor('#7F4EAD', 20) : 'transparent'}; 
  }
`;

const CountryName = styled.div<{mode?: any}>`
  color:${p=> p.mode == 'dark' ? 'white' : '#4E5156'} ;
  margin-left: 5px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const TopTooltipSection = styled.div<{mode?: any}>`
  padding: 12px 11px;
  color: ${p=> p.mode == 'dark' ? 'white' : ''};

`;
const BottomTooltipSection = styled.div<{mode?: any}>`
  background-color:${p=> p.mode == 'dark' ? '#2D2F34' : '#F9F9FB'};
  padding: 12px 11px;
  color: ${p=> p.mode == 'dark' ? 'white' : ''};
`;
